import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {LOV} from "../../../core/models/listOfValue.model";
import {Tehsil} from "../../../core/models/tehsil.model";
import {ApplicationDataService} from "../../../core/services/application-data.service";
import {AppUrlConstants} from "../../../core/constants/AppUrlConstants";
import {GenericCrudService} from "../../../core/services/generic-crud.service";
import {AlertDialogComponent} from "../../../shared/alert-dialog/alert-dialog.component";

@Component({
  selector: 'app-add-edit-dialog-mouza',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
    ReactiveFormsModule, MatDialogClose, TranslateModule, MatCheckbox, MatOption, MatSelect],
  templateUrl: './add-edit-mouza.component.html'
})
export class AddEditMouzaComponent implements OnInit{
  divisionList: LOV[] = [];
  districtList: LOV[] = [];
  tehsilList: LOV[] = [];
  filteredListDivision: any[] = [];
  filteredListDistrict: any[] = [];
  filteredListTehsil: any[] = [];
  segmentType:string = "NONE";
  form: FormGroup;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AddEditMouzaComponent>,
      public dialog: MatDialog, private formBuilder: FormBuilder,
      private crudService: GenericCrudService,
      private appDataService: ApplicationDataService
      ) {
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      adminStrId: [null],
      division: ['', [Validators.required]],
      district: ['', [Validators.required]],
      tehsil: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.maxLength(60),]],
      description: ['', [Validators.required, Validators.maxLength(300),]],
      parentAdminStrId: [],
      pulse: [false],
      plra: [false],
      segmentType:[],
      adminStructureTypes: "MOUZA"
    });
  
    this.getDivisionList();
    this.onValueChangeDivision();
    this.onValueChangeDistrict();
  
    if(this.data != null) {
      this.updateSegment(this.data);
      
      // Set the known values immediately
      this.form.patchValue({
        adminStrId: this.data.adminStrId,
        name: this.data.name,
        description: this.data.description,
        parentAdminStrId: this.data.parentAdminStrId,
        pulse: this.data.pulse,
        plra: this.data.plra
      });
      
      // Get the tehsil details first
      this.appDataService.getByType("TEHSIL").subscribe({
        next: (allTehsils: any) => {
          if (allTehsils && allTehsils.data) {
            // Find our tehsil
            const tehsil = allTehsils.data.find((t: any) => 
              t.adminStrId === this.data.parentAdminStrId
            );
            
            if (tehsil) {
              // Now get district details
              this.appDataService.getByType("DISTRICT").subscribe({
                next: (allDistricts: any) => {
                  if (allDistricts && allDistricts.data) {
                    // Find our district
                    const district = allDistricts.data.find((d: any) => 
                      d.adminStrId === tehsil.parentAdminStrId
                    );
                    
                    if (district) {
                      // Set division first
                      this.form.patchValue({
                        division: district.parentAdminStrId
                      });
                      
                      // Wait for division change to trigger district loading
                      setTimeout(() => {
                        this.form.patchValue({
                          district: district.adminStrId
                        });
                        
                        // Wait for district change to trigger tehsil loading
                        setTimeout(() => {
                          this.form.patchValue({
                            tehsil: this.data.parentAdminStrId
                          });
                        }, 10);
                      }, 10);
                    }
                  }
                },
                error: (e) => {
                  console.error("Error fetching districts:", e);
                  this.openAlert("Error loading district data");
                }
              });
            }
          }
        },
        error: (e) => {
          console.error("Error fetching tehsils:", e);
          this.openAlert("Error loading tehsil data");
        }
      });
    }
  }
  getDivisionList(){
    this.appDataService.getByType("DIVISION").subscribe({
      next: (res: any) => {
        res.data.forEach((item:any) => {
          this.divisionList.push(item);
          // Initialize filtered list for Division
          this.filteredListDivision = this.onFilteredListSearch(null, this.divisionList, 'name');
        });
      }
    });
  }
  onValueChangeDivision() {
    this.form.controls['division'].valueChanges.subscribe({
      next: (data: any) => {
        // Reset the district and tehsil when division changes
        this.form.controls['district'].setValue('');
        this.form.controls['tehsil'].setValue('');
        
        // Mark them as touched to trigger validation display immediately
        this.form.controls['district'].markAsTouched();
        this.form.controls['tehsil'].markAsTouched();
        
        // Load districts for the new division
        this.getDistrictByDivisions(data);
      }
    })
  }
  
  onValueChangeDistrict() {
    this.form.controls['district'].valueChanges.subscribe({
      next: (data: any) => {
        // Reset the tehsil when district changes
        this.form.controls['tehsil'].setValue('');
        
        // Mark it as touched to trigger validation display immediately
        this.form.controls['tehsil'].markAsTouched();
        
        // Load tehsils for the new district
        this.getTehsilByDistricts(data);
      }
    })
  }
  getDistrictByDivisions(id: any) {
    this.districtList = [];
    // Only make the API call if id is valid
    if (id) {
      this.appDataService.getAdmStructurebyParentId(id).subscribe({
        next: (res: any) => {
          res.data.forEach((item:any) => {
            this.districtList.push(item);
            // Initialize filtered list for District
            this.filteredListDistrict = this.onFilteredListSearch(null, this.districtList, 'name');
          });
        },
        error: (e) => {
          console.error("Error fetching districts:", e);
        }
      });
    }
  }
  
  getTehsilByDistricts(id: any) {
    this.tehsilList = [];
    // Only make the API call if id is valid
    if (id) {
      this.appDataService.getAdmStructurebyParentId(id).subscribe({
        next: (res: any) => {
          res.data.forEach((item:any) => {
            this.tehsilList.push(item);
            // Initialize filtered list for Tehsil
            this.filteredListTehsil = this.onFilteredListSearch(null, this.tehsilList, 'name');
          });
        },
        error: (e) => {
          console.error("Error fetching tehsils:", e);
        }
      });
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  add() {
    this.setSegment(this.form.value);
    this.form.patchValue({segmentType: this.segmentType});
    this.form.patchValue({parentAdminStrId: this.form.value.tehsil});
    console.log(this.form.value);
    this.crudService.add(this.form.value, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.ADD).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  edit() {
    this.setSegment(this.form.value);
    this.form.patchValue({segmentType: this.segmentType});
    this.form.patchValue({parentAdminStrId: this.form.value.tehsil});
    console.log(this.form.value);
    this.crudService.add(this.form.value, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.EDIT).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  setSegment(result: any){
    if (result.pulse && result.plra) {
      this.segmentType = 'ALL';
    } else if (!result.pulse && !result.plra) {
      this.segmentType = 'NONE';
    } else {
      this.segmentType = result.pulse ? 'PULSE' : 'PLRA';
    }
  }
  updateSegment(updateRecord: Tehsil){
    switch (updateRecord.segmentType) {
      case 'ALL':
        updateRecord.pulse = true;
        updateRecord.plra = true;
        break;
      case 'NONE':
        updateRecord.pulse = false;
        updateRecord.plra = false;
        break;
      case 'PULSE':
        updateRecord.pulse = true;
        updateRecord.plra = false;
        break;
      case 'PLRA':
        updateRecord.pulse = false;
        updateRecord.plra = true;
        break;
      default:
        // Handle any other cases if needed
        break;
    }
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }

  onFilteredListSearch(event: any, originalList: any[], property: string): any[] {
    let filteredList: any[];
    if (event && event.target.value) {
      filteredList = originalList.filter(item => item[property].toLowerCase().includes(event.target.value.toLowerCase()));
    } else {
      filteredList = originalList; // Copy the original list
    }
    return filteredList;
  }

  onOptionSelected(event: any, formControlName: string) {
  
    const searchInput = document.getElementById('search-select') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }
    // Reset the filtered list to the original list
    if (formControlName === 'division') {
      this.filteredListDivision = this.divisionList;
    };

    if (formControlName === 'district') {
      this.filteredListDistrict = this.districtList;
    };

    if (formControlName === 'tehsil') {
      this.filteredListTehsil = this.tehsilList;
    };
  }

}
